import {doGet, doPost} from './Api';

export default class SurveyService {
  static async getSurveyInfo() {
    const response = await doGet(`${process.env.REACT_APP_SURVEY}/SATISFACCION12345`);
    return response.data;
  }
}